export default "/public/dist/img/cattura.png";